<template>
  <div class="p-inputgroup">
    <!-- InputText for search -->
    <InputText
      v-model="searchQuery"
      placeholder="Search..."
      @input="onSearch"
    />

    <!-- Button with down arrow inside the input box -->
    <Button
      icon="pi pi-chevron-down"
      class="p-button-secondary"
      @click="toggleDropdown"
    />

    <!-- Select component for search type -->
    <Dropdown
      v-if="showDropdown"
      v-model="selectedSearchType"
      :options="searchTypes"
      option-label="label"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';

// Reactive references
const searchQuery = ref('');
const selectedSearchType = ref(null);
const showDropdown = ref(false);

// Options for the Select component
const searchTypes = [
    { label: 'Name', value: 'name' },
    { label: 'Client', value: 'client' },
    { label: 'Project Number', value: 'projectNumber' },
    { label: 'Status', value: 'status' },
];

// Toggle dropdown visibility
const toggleDropdown = () => {
    showDropdown.value = !showDropdown.value;
};

// Handle search input
const onSearch = () => {
    console.log('Search query:', searchQuery.value);
};
</script>

<style scoped>
.p-inputgroup {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 400px;
    /* Adjust width as needed */
}

.search-type-select {
    position: absolute;
    right: 0;
    z-index: 1000;
}
</style>